import React, {useRef} from 'react';
import {Alert, Button} from "react-bootstrap";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {WhiteCard} from "../_components/WhiteCard";
import {useGetJson, useLongPress, useSelect, useTouch} from "../../../hooks";
import {capitalizeFirstLetter, endpoints, RepeatType as EventTypes, RepeatType, timeUTCMinToLocalString} from "../../../utils2";
import {useAuth} from "../../../context";
import {EventType1, EventType2, RelayAction} from "../../../utils2/maps";
import {MenuClearSelectButton, MenuConfirmDeleteButton} from "../../_components";
import {RenderControlledBy, RenderDailyShort} from "../_components/UsefulComponents";
import {ABOverlayTooltip} from "../../_components/CustomOverlayTooltip";
import {buildEventSteps} from "./utils";

export function ConfigurationCard({configure, events, onDelete}) {
    const {uid, did} = useParams()
    const location = useLocation()
    const navigate = useNavigate()

    const filteredEvents = events.filter(event => event.event_type2 === configure.event_type2)
    const disableAlways = events.some(event => configure.overlapFilters.includes(event.event_type2))
    const disableControl = disableAlways
    const disableAuto = events.some(event => event.name === "ALWAYS" || event.event_type1 === EventType1.ControlledBy)

    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(filteredEvents)

    const ButtonList = [
        {
            type1: "ALWAYS",
            name: "Always",
            variant: "primary",
            icon: "bi bi-infinity",
            disabled: disableAlways,
            path: "",
            tip: "Set Always Stream",
            show: configure.always,
        },
        {
            type1: EventType1.Automation,
            name: "Automation",
            variant: "primary",
            icon: "bi bi-arrow-repeat",
            disabled: disableAuto,
            path: "time/new",
            tip: "Set Automation",
            show: true,
        },
        {
            type1: EventType1.ControlledBy,
            name: "Controlled-By",
            variant: "primary",
            icon: "bi bi-hdd-network",
            disabled: true,//disableControl,
            path: "cnrt/new",
            tip: "Set Controller Device",
            show: true,
        },
    ]

    function handleClick(type1, pathId, stpIdx) {
        buildEventSteps(uid, did, configure.path, configure.advPlayback, location, navigate, type1, pathId, stpIdx);
    }

    return <>
        <WhiteCard>
            <div className=" d-flex align-items-center pb-1 border-bottom">
                <div className="fw-semibold fs-5">{configure.title}</div>
                <div className="d-flex ms-auto gap-2">
                    {ButtonList
                        .filter(item => item.show)
                        .map((item, index) => {

                            const button = (
                                <Button
                                    variant={item.variant}
                                    onClick={() => handleClick(item.type1, "new", 1)}
                                    disabled={item.disabled}
                                >
                                    <span className="d-none d-lg-block">{item.name}</span>
                                    <span className={`d-lg-none ${item.icon}`}></span>
                                </Button>
                            )

                            return item.disabled ? (
                                <ABOverlayTooltip key={index} tip="A controlled event already exists"><span>{button}</span></ABOverlayTooltip>
                            ) : (

                                <ABOverlayTooltip key={index} tip={item.tip}><span>{button}</span></ABOverlayTooltip>
                            );
                        })}

                    {selList.length > 0 &&
                        <>
                            <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
                                {selList.length} {selList.length === 1 ? "item" : "items"}
                            </MenuClearSelectButton>
                            <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={() => onDelete(selList)}>
                                <span>{selList.length} {selList.length === 1 ? "event" : "events"}</span>
                            </MenuConfirmDeleteButton>
                        </>}
                </div>
            </div>
            <div>
                {filteredEvents && filteredEvents.length > 0 ?
                    filteredEvents.map((event, index) =>
                        <RenderEvent key={index} eventId={event.id} selected={isItemSelected(event.id)} onSelect={toggleSelectItems}
                                     selectedCount={selList.length}
                                     handleClick={handleClick}/>
                    ) :
                    <div>No settings have been configured yet</div>
                }
            </div>
        </WhiteCard>
    </>
}

function RenderEvent({eventId, selected, selectedCount, onSelect, handleClick}) {
    const {uid, did} = useParams()
    const {authToken} = useAuth()
    const navigate = useNavigate()

    const touch = useTouch()
    const ref = useRef(null)
    useLongPress(ref, () => onSelect(eventId))

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(endpoints.event.get(eventId), authToken?.jwt)
    const event = ev?.data

    const config1 = event?.config1
    const config2 = event?.config2

    const truncate = (str, max = 20) => str?.length > max ? `${str.substring(0, max)}...` : str

    // const toEditEventType1 = event?.event_type1 === EventType1.Automation ? `/device/${uid}/${did}/time/${event?.id}` : `/device/${uid}/${did}/cntr/${event?.id}`
    // const toEditEventType2 = (event?.event_type2 === EventType2.Playback || event?.event_type2 === EventType2.Sender) ?
    //     `/device/${uid}/${did}/${event?.event_type2}/${event?.id}` :
    //     `/device/${uid}/${did}/${event?.event_type2}${config2?.index}/${event?.id}`


    return (
        <div ref={ref} className={`d-flex align-items-center gap-2 p-1 mb-2 rounded ${(selected ? "bg-secondary-subtle" : "hover-bg-secondary-subtle")}`}>

            <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>

            <div className="d-flex w-100 flex-column flex-sm-row align-items-sm-center">
                <div className="d-flex align-items-start gap-2">
                    {
                        event?.name === "ALWAYS" ?
                            <div className="fw-medium">Always</div> :
                            <div className="d-flex flex-column align-items-start">
                                <span className="fw-medium">{truncate(event?.name, 30)}</span>
                                <Button variant="link" onClick={() => handleClick(event?.event_type1, event?.id, 1)} disabled={event?.name === RepeatType.Always}
                                        className="p-0 flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">

                                    {event?.name !== RepeatType.Always && event?.event_type1 === EventType1.Automation && (
                                        <div className="d-flex flex-column flex-md-row">
                                            {config1.repeat === RepeatType.Daily ? (
                                                <div className="d-flex">
                                                    <RenderDailyShort config1={config1}/>
                                                    <div className="me-1 fw-light">;</div>
                                                </div>
                                            ) : (
                                                <div className="d-flex">
                                                    <div
                                                        className="fw-light">{`${capitalizeFirstLetter(config1.weekly_start.slice(0, 3))} - ${capitalizeFirstLetter(config1.weekly_stop.slice(0, 3))}`}</div>
                                                    <div className="me-1 fw-light">;</div>
                                                </div>
                                            )}
                                            {/*<div className="me-1 fw-light">;</div>*/}
                                            <div className="fw-light">
                                                {`${timeUTCMinToLocalString(config1?.time_start)} - ${timeUTCMinToLocalString(config1?.time_stop)}`}
                                            </div>
                                        </div>
                                    )}

                                    {event?.event_type1 === EventType1.ControlledBy && <RenderControlledBy config1={config1}/>}
                                </Button>
                            </div>
                    }
                </div>
                <div className="ms-sm-auto">
                    {/*<Button variant="link" onClick={() => handleClick(event?.event_type1, event?.id, 2)}*/}
                    {/*        className="px-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">*/}
                    {/*    {event?.event_type2 === EventType2.Playback && <span className="">{truncate(config2?.main_host, 30)}</span>}*/}
                    {/*    {event?.event_type2 === EventType2.Sender && <span className="">{truncate(config2?.uri, 30)}</span>}*/}
                    {/*    {event?.event_type2 === EventType2.Relay1 && <span className="">{RelayAction[config2?.action].name}</span>}*/}
                    {/*</Button>*/}
                </div>
            </div>

            <div className="ms-auto">

                <div className="d-flex align-items-center gap-2">
                    {event?.announcements.length > 0 &&
                        <Button variant="link" onClick={() => handleClick(event?.event_type1, event?.id, 3)}
                                className="px-0 link-underline link-underline-opacity-0">
                            <i className="bi bi-megaphone fs-4"/>
                        </Button>}

                    <Button variant="link" onClick={() => handleClick(event?.event_type1, event?.id, 2)}
                            className="px-0 link-underline link-underline-opacity-0">
                        {event?.event_type2 === EventType2.Playback &&
                            <i className="bi bi-menu-button-wide fs-5"/>} {/*<span className="">{truncate(config2?.main_host, 30)}</span>*/}
                        {event?.event_type2 === EventType2.Sender &&
                            <i className="bi bi-menu-button-wide fs-5"/>} {/*<span className="">{truncate(config2?.uri, 30)}</span>*/}
                        {event?.event_type2 === EventType2.Relay1 &&
                            <i className="bi bi-pci-card-network fs-5"/>} {/*<span className="">{RelayAction[config2?.action].name}</span>*/}
                    </Button>
                    {(!touch || selected || selectedCount > 0) &&
                        <Button className="px-0 link-underline link-underline-opacity-0" variant="link"
                                onClick={() => onSelect(eventId)}>
                            <span className={`fs-5 bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                        </Button>
                    }
                </div>
            </div>
        </div>

    )
}


